<template>
  <div class="user-container" ref="usercontainer">
    <el-row class="user-button">

      <el-button type="primary" @click="dialogAddFormVisible = true"><i class="el-icon-plus"></i>新增部门</el-button>

    </el-row>
    <el-row class="user-con">
      <template >
        <el-table
            :data="tableData"
            style="width: 100%;height:100%;">
          <el-table-column
              prop="id"
              label="部门ID"
          >
          </el-table-column>
          <el-table-column
              prop="name"
              label="部门名称"
          >
          </el-table-column>
          <el-table-column
              label="上级部门"
          >
            <template  slot-scope="scope">{{ scope.row.parentId | PartentIdtoString}}</template>
          </el-table-column>
          <el-table-column
              prop="level"
              label="层级"
          >
          </el-table-column>
          <el-table-column
              prop="updateTime"
              label="更新时间"
          >
          </el-table-column>

          <el-table-column
              label="操作"
          >
            <template slot-scope="scope">
              <el-row>
                <el-button type="primary" icon="el-icon-edit" circle @click="openUpdate(scope.row.id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" circle @click="openDelete(scope.row.id)"></el-button>
              </el-row>
            </template>

          </el-table-column>
        </el-table>
      </template>
    </el-row>


    <!--    新增部门-->
    <!-- Form -->
    <el-dialog title="新增部门" :visible.sync="dialogAddFormVisible">
      <el-form :model="addForm" style="text-align: left">
        <el-form-item label="上级部门" :label-width="formLabelWidth">
          <el-select v-model="addForm.parentId" placeholder="请选择上级部门">
            <el-option label="桓仁红色教育服务中心" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称" :label-width="formLabelWidth" style="width:60%">
          <el-select v-model="addForm.name" placeholder="请选择所在部门" >
            <el-option label="东北抗日义勇军纪念馆" value="东北抗日义勇军纪念馆"></el-option>
            <el-option label="李秋实纪念馆" value="李秋实纪念馆"></el-option>
            <el-option label="桓仁抗战红都教育服务中心" value="桓仁抗战红都教育服务中心"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAddFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit(addForm)">确 定</el-button>
      </div>
    </el-dialog>
    <!-- Form -->
    <!--修改部门-->
    <el-dialog title="新增部门" :visible.sync="dialogUpdateFormVisible">
      <el-form :model="updateForm" style="text-align: left">
        <el-form-item label="上级部门" :label-width="formLabelWidth">
          <el-select v-model="updateForm.parentId" placeholder="请选择上级部门">
            <el-option label="桓仁红色教育服务中心" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门名称" :label-width="formLabelWidth" style="width:60%">
          <el-select v-model="updateForm.name" placeholder="请选择所在部门" >
            <el-option label="东北抗日义勇军纪念馆" value="东北抗日义勇军纪念馆"></el-option>
            <el-option label="李秋实纪念馆" value="李秋实纪念馆"></el-option>
            <el-option label="桓仁抗战红都教育服务中心" value="桓仁抗战红都教育服务中心"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogUpdateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateSubmit(updateForm)">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {request} from "@/request/request";

export default {
  name: "UserDeptAdmin",
  data(){
    return {
      tableData: [],
      total:0,
      pageSize:100,
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      dialogAddFormVisible:false,
      dialogUpdateFormVisible:false,
      addForm:{
        name:'',
        parentId:''
      },
      updateForm:{
        name:'',
        parentId:''
      },
      formLabelWidth: '120px',
      restfulUrl:'depts',//获取全部列表
    }
  },
  methods:{
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    updateSubmit(data){
      console.log(data)
    },
    addSubmit(data){
      data.parentId = parseInt(data.parentId);
      this.addForm = {
        name:'',
        parentId:''
      }
      this.dialogAddFormVisible = false;

        request({
          method:'POST',
          url:'/depts',
          data:data
        }).then(res =>{
          if(res.code == 1){

            this.$message({
              type: 'success',
              message: '新增成功!',
            });
            this.getData();
          }
        },err=>{
          console.log(err)
        })
    },
    getData:function(){//获取全部数据
      request({
        method:'GET',
        url:this.restfulUrl,
      }).then(res =>{
        this.tableData = res.data;
      },err=>{
        console.log(err)
      })
    },
    deleteById:function(uid){
      request({
        method:'DELETE',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        if(res.code==1){
          this.$message({
            type: 'success',
            message: '删除成功!',
          });
          this.getData();
        }
      },err=>{
        console.log(err)
      })
    },
    openUpdate(uid){
      this.updateForm.id = uid;
      this.dialogUpdateFormVisible = true;
      request({
        method:'GET',
        url:this.restfulUrl+'/'+uid,
      }).then(res =>{
        console.log(res)
        if(res.code==1){
          this.updateForm = res.data;
        }
      },err=>{
        console.log(err)
      })
    },
    openDelete(uid) {
      this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteById(uid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  },
  mounted() {
    this.getData();
    // this.getPageCount();
  },
  filters:{

    PartentIdtoString(id){
      if(id ==0){
        var newId = '桓仁红色教育服务中心'
      }
      return newId
    },
  }

}
</script>

<style scoped>
.user-button{
  text-align: left;
  padding:0 10px 10px;
  border-bottom: 1px solid rgb(165,165,165);
}
.user-container{
  height:100%;
}
.user-con{
  padding:40px;
}
</style>
